<template>
	<Modal
		:allow-close="false"
		:hide-actions="true"
		:max-width="'max-w-[485px]'"
		rounded-size="rounded-[10px]"
		:prevent-scrolling="false"
		:remove-padding="true"
	>
		<template #body>
			<div class="flex flex-col gap-6 p-6 font-[Inter]">
				<h2 class="text-center text-xl leading-7 font-semibold text-gray-900">
					A few quick questions
				</h2>
				<QualificationForm
					:processing="processing"
					:errors="errors"
					@submit="submit"
				/>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { ref } from 'vue';
import { toast } from 'vue-sonner';

import Modal from '../../components/modal.vue';
import QualificationForm from '../../components/onboarding/qualification-form.vue';
import { submitQualification } from '../../api/onboarding';
import { useExistingUserAutoApplyStore } from '../../store/existing-user-auto-apply.store';

const store = useExistingUserAutoApplyStore();

const processing = ref(false);
const errors = ref({});

/** Laravel sends a list of messages per field; the form shows one, like Inertia's errors. */
const firstMessages = (fieldErrors) => Object.fromEntries(
	Object.entries(fieldErrors).map(([field, messages]) => [field, [].concat(messages)[0]]),
);

const submit = async (answers) => {
	processing.value = true;
	errors.value = {};

	try {
		await submitQualification(answers);
		store.showPreferences();
	} catch (error) {
		if (error?.status === 422 && error.fieldErrors) {
			errors.value = firstMessages(error.fieldErrors);
		} else {
			toast.error('Something went wrong saving your answers. Please try again.');
		}
	} finally {
		processing.value = false;
	}
};
</script>
